<template>
    <div>
        <!-- Begin Page Content -->
        <div class="Diebetes-Program">
            <div class="row">
                <div class="col-md-7 col-12 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-3">
                            <h2 class="d-flex align-items-center">
                                <router-link to="/mannual-prescription"><i class="icon icon-chevron-down"></i> Add Medicine to Diebetes Program</router-link >
                            </h2>
                            <div class="row no-gutters justify-content-center mt-4">
                                <div class="col-lg-10">
                                    <form class="add-medicine text-center">
                                        <div class="input-group mb-4">
                                            <input type="text" name="text" placeholder="Azulix O MF Forte " />
                                            <button type="button" class="btn btn-search"><i class="icon icon-search"></i></button>
                                        </div>

                                        <div class="row mb-4">
                                            <div class="col-lg-6">
                                                <div class="input-group">
                                                    <input type="text" name="text" placeholder="No of Tablet" />
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="input-group">
                                                    <select>
                                                        <option>50 mg</option>
                                                        <option>100 mg</option>
                                                        <option>200 mg</option>
                                                        <option>300 mg</option>
                                                        <option>400 mg</option>
                                                        <option>500 mg</option>
                                                        <option>100 mg</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="input-group mb-4">
                                            <input type="text" name="text" placeholder="No of Days" />
                                        </div>
                                        <router-link class="btn btn-blue Medicine-List mt-1" to="/mannual-prescription">Add Medicine</router-link>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 mb-4 text-left prescription-name">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-3 text-left">
                            <h2>Azulix O MF Forte</h2>
                            <figure><img src="../../../../static/website/images/Azulix-O-MF-Forte.svg" /></figure>
                            <div class="text-left">
                                <h3>Manufacturer</h3>
                                <p>Torrent Pharmaceuticals Ltd</p>
                                <h3>Salt Composition</h3>
                                <p>Glimepiride (1mg) + Metformin (1000mg)</p>
                                <h3>Storage</h3>
                                <p>Store below 30°C</p>
                                <h3>Uses of Azulix MF Tablet PR</h3>
                                <p>Type 2 Diabetes Mellitus</p>
                            </div>
                            <router-link to="/prescription-product" class="click-here">Click Here to know more</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid Diebetes-list-section">
            <div class="row mr-0">
                <div class="col-lg-12 col-md-12 col-sm-12 mb-4 pl-4">
                    <div class="bg-white border-radius-5 p-4">
                        <div class="card-body bg-white border-radius-5 p-0 h-100">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h2>Your Diebetes List</h2>
                                <router-link class="btn btn-blue Create-Prescription" to="/prescription-list">Create Prescription List</router-link>
                            </div>
                            <div class="table-responsive">
                                <table class="table Medicine-list mb-0 border-0" border="0" cellspacing="0" cellpadding="0">
                                    <thead>
                                        <tr>
                                            <th>Medicine Name</th>
                                            <th>Dosage</th>
                                            <th>Duration</th>
                                            <th>&nbsp;</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><span>1. Ceruvin 75</span></td>
                                            <td>2 times(Morning and Evening )</td>
                                            <td>10 Days, Total Tablet : 10</td>
                                            <td><a href="#">Analyze your medicine</a></td>
                                            <td><i class="icon icon-close"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Add-New-Medicine",
        data() {
            return {};
        },
        created(){
           this.pageName('Add Prescription')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/medicines/add-medicine.vue